var React = require('react');

function Sneakers (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 22V19.2105C1 18.3641 1.52652 17.5973 2.30952 17.2895C3.04299 17.0087 3.72543 16.6038 4.35238 16.1316C5.0625 15.5967 5.6731 14.9254 6.18049 14.1805L8 16L9 15L6.91404 12.914C7.14155 12.4489 7.33405 11.9705 7.49085 11.4908L10 14L11 13L7.88362 9.88362C7.96095 9.4052 8 8.93969 8 8.5L9.5 7.5L11 9L13.5 6.5L13.5 3.5L15 2L23 10L19 14H17L16 15L15.5 17.5L11 22H1Z","fill":"currentColor"}));
}

Sneakers.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Sneakers;

Sneakers.default = Sneakers;
